import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UrlProviderService {

  public get ApiUrl(): string {
    return environment.portalBackend.apiUrl;
  }

  public get ServerUrl(): string {
    return environment.portalBackend.serverUrl;
  }

  public get AiAnalyzerUrl(): string {
    return environment.aiAnalysis.apiUrl;
  }
}
